define(function (require) {
    var Backbone = require("backbone");
    var $ = require('jquery');
    var _ = require("underscore");
    var ModalsFactory   = require('modals/factory');

    var errorCodes = {
        //'4××': "Client Error",
        400: "Bad Request",
        401: "Unauthorized",
        402: "Payment Required",
        403: "Forbidden",
        404: "Not Found",
        405: "Method Not Allowed",
        406: "Not Acceptable",
        407: "Proxy Authentication Required",
        408: "Request Timeout",
        409: "Conflict",
        410: "Gone",
        411: "Length Required",
        412: "Precondition Failed",
        413: "Payload Too Large",
        414: "Request-URI Too Long",
        415: "Unsupported Media Type",
        416: "Requested Range Not Satisfiable",
        417: "Expectation Failed",
        418: "I'm a teapot",
        421: "Misdirected Request",
        422: "Unprocessable Entity",
        423: "Locked",
        424: "Failed Dependency",
        426: "Upgrade Required",
        428: "Precondition Required",
        429: "Too Many Requests",
        431: "Request Header Fields Too Large",
        444: "Connection Closed Without Response",
        451: "Unavailable For Legal Reasons",
        499: "Client Closed Request",
        //'5××': "Server Error",
        500: "Internal Server Error",
        501: "Not Implemented",
        502: "Bad Gateway",
        503: "Service Unavailable",
        504: "Gateway Timeout",
        505: "HTTP Version Not Supported",
        506: "Variant Also Negotiates",
        507: "Insufficient Storage",
        508: "Loop Detected",
        510: "Not Extended",
        511: "Network Authentication Required",
        599: "Network Connect Timeout Error",
    };

    var recentErrors = [];
    window.recentErrors = recentErrors;
    var maxNumberRecentErrors = 15;

    Backbone.ajax = function (request) {
        var old_fail = false;
        var old_success = false;
        var projectId = app && app.currentProjectId;
        var token = app.storage.read('authToken') || $.cookie('bearer_token');

        if (typeof request.error !== 'undefined')
            old_fail = request.error;

        if (typeof request.success !== 'undefined')
            old_success = request.success;


        if(projectId && request.url.indexOf('project_id=') == -1) {
            request.url = request.url + (request.url.indexOf('?')>=0 ? '&' : '?') + 'project_id='+ projectId;
        }
        var parseServerData = function (request, sdata) {
            if (typeof sdata !== 'undefined') {
                var log_data = [];
                log_data.push('Request "' + ((typeof request.type != 'undefined') ? (request.type + ':') : '') + ' ' + request.url + '"');

                if (typeof sdata.time !== 'undefined')
                    log_data.push('completed in ' + sdata.time + ' sec');

                if (typeof sdata.memory !== 'undefined')
                    log_data.push('[memory: ' + sdata.memory.total + ']');
            }
        };

        var getErrorShortDescription = function (timeMark, xhr, textStatus, errorThrown, request) {
            var type = request.type || 'GET',
                code = xhr.status,
                codeDescription = errorThrown,
                url = request.url;

            return '<span class="js-error-response js-modal" data-modal="js_error" data-id="' + timeMark + '" onclick="showMoreDetails(this)">' +
                '<i class="fa fa-arrows-alt">' +
                '</i><span title="' + codeDescription + '"> ' +
                ' ' + type + ' ' +
                '(' + code + ') ' + url +
                '</span>' +
                '</span>';
        };

        var showMoreDetails = function (element) {
            var modalData = $(element).data();
            var path = $(element).data('modal');

            ModalsFactory.create('js-error', function(ModalError) {
                app.regionModal.show(new ModalError({
                    curElement: $(element),
                    modalData: recentErrors.filter(function (item) {
                        return modalData.id === item.id
                    })
                }));
            })
        };
        window.showMoreDetails = showMoreDetails;

        var addNewError = function (data) {
            data.show = function () {
                var message = getErrorShortDescription(data.id, data.xhr, data.textStatus, data.errorThrown, data.request)
                app.message.error(message);
            };
            recentErrors.push(data);

            if (recentErrors.length > maxNumberRecentErrors) {
                recentErrors.shift();
            }
        };

        request = _.extend(request, {
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true,
            beforeSend: function (jqXHR, settings) {
                if (token) {
                    jqXHR.setRequestHeader('Authorization', 'Bearer ' + token);
                }
                return true;
            },
            success: function(response, textStatus, xhr) {
                if (response && typeof response._server_ !== 'undefined') {
                    parseServerData(request, response._server_);
                }

                if (old_success)
                    old_success.apply(null, [response, textStatus, xhr]);
            },

            error: function(xhr, textStatus, errorThrown) {
                app.Vents.trigger('app:unBlockUi');
                var timeMark = (new Date()).getTime();
                addNewError({
                    id: timeMark,
                    xhr: xhr,
                    textStatus: textStatus,
                    errorThrown: errorThrown,
                    request: request
                });

                // FOR NOW, WE DON'T SHOW 4xx,5xx ERRORS
                if (xhr.status == 401) {
                    location.href = '/login';
                }
                if (xhr.status == 600) {
                    location.href = '//lptracker.ru'
                }
                if (xhr.status == 504) {
                    // app.message.error('Время ожидания превышено. Пожалуйста, повторите запрос позже либо обратитесь в клиентский сервис');
                }

                if(xhr.status === 500) {
                    // app.mainController.AjaxError();
                }

                var redirect = false;
                if (typeof xhr.responseText !== 'undefined' &&
                    xhr.responseText !== '' && xhr.responseText != 'null') {

                    try {
                        var json = $.parseJSON(xhr.responseText);

                        if (typeof json.server !== 'undefined')
                            parseServerData(request, json._server_);

                        if (typeof json.status !== 'undefined' && json.status == 0) {
                            if (typeof json.redirect !== 'undefined') {
                                var params = [];
                                if (typeof json.params !== 'undefined') {
                                    params = json.params;
                                }

                                var access_redirect = true;
                                if (app.lastView !== 'undefined') {
                                    if (app.lastView.pageName == 'Tariffs') {
                                        if (typeof params.page !== 'undefined') {
                                            if (params.page == 'Tariffs') {
                                                access_redirect = false;
                                            }
                                        }
                                    } else if (typeof app.lastRedirect !== 'undefined' && app.lastRedirect == json.redirect) {
                                        access_redirect = false;
                                    }
                                }

                                if (access_redirect) {
                                    app.lastRedirect = json.redirect;
                                    window.location.href = json.redirect;
                                    redirect = true;
                                }
                            }
                        }
                    } catch (e) {}
                }

                if (!redirect && old_fail) {
                    old_fail.apply(null, [xhr, textStatus, errorThrown]);
                }
            }
        });

        return Backbone.$.ajax.apply(Backbone.$, [request]);
    };
});
